import * as Yup from 'yup';

/**
 * Creates a validation rule for impressions that must be greater than a previous period
 * @param previousFields - Array of field names to check in order, from most recent to oldest
 * @param label - The label to use in the error message
 */
export const createImpressionValidation = (previousFields?: string[]) => {
  const baseValidation = Yup.number()
    .nullable()
    .min(0, 'Must be a positive number');

  if (!previousFields?.length) {
    return baseValidation;
  }

  return baseValidation.test({
    name: 'greater-than-previous',
    message: 'Must be empty or higher than earlier impressions',
    test: function validateGreaterThan(value) {
      // If current value is empty/null, validation passes
      if (value === null || value === undefined) {
        return true;
      }

      // Find the first non-empty previous value and its index
      const foundField = previousFields.find(
        (field) =>
          this.parent[field] !== null &&
          this.parent[field] !== undefined &&
          this.parent[field] !== '',
      );

      const comparisonValue = foundField ? this.parent[foundField] : null;

      // If no previous value found, validation passes
      if (comparisonValue === null) {
        return true;
      }

      if (Number(value) < Number(comparisonValue)) {
        return this.createError({
          message: 'Must be empty or higher than earlier impressions',
        });
      }

      return true;
    },
  });
};
